import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
const api = axios.create({ baseURL: '/api/v1', headers: { 'Content-Type': 'application/json' } });
api.interceptors.request.use((config) => {
  const tokens = useAuthStore.getState().tokens;
  if (tokens?.accessToken) config.headers.Authorization = 'Bearer ' + tokens.accessToken;
  const stationId = useAuthStore.getState().user?.stationId;
  if (stationId) config.headers['X-Station-Id'] = stationId;
  return config;
});
api.interceptors.response.use((r) => r, async (error) => {
  if (error.response?.status === 401 && !error.config._retry) {
    error.config._retry = true;
    const tokens = useAuthStore.getState().tokens;
    if (tokens?.refreshToken) {
      try {
        const res = await axios.post('/api/v1/auth/refresh-token', { refreshToken: tokens.refreshToken });
        useAuthStore.getState().setTokens(res.data.data.tokens);
        error.config.headers.Authorization = 'Bearer ' + res.data.data.tokens.accessToken;
        return api(error.config);
      } catch { useAuthStore.getState().logout(); }
    }
  }
  return Promise.reject(error);
});
export default api;
